// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22yHx","colBig":"styles_colBig__3d20u","colSmall":"styles_colSmall__S9LrN"};